export default {"src":"/_next/static/image/public/images/flags/flag_590.441cfe7b713a3344cbd81b9b3f65f601.svg","height":16,"width":24};